exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".rulesIntro{display:block;width:80%;padding:0px 100px;margin:auto;margin-top:20px;background:#ffffff;box-shadow:0px 1px 2px rgba(0,0,0,0.05);height:calc( 100vh - 325px)}.rulesIntro .carousel-caption{top:50%;transform:translateY(-50%);text-align:left;right:0;left:50%}.rulesIntro .carousel-caption h3{font-size:30px;font-weight:600;margin-top:0}.rulesIntro .carousel-caption p{font-size:15px;color:#7c7c7c;font-weight:400}.rulesIntro .imgSection{right:50%;padding-right:50px}.rulesIntro .imgSection img{width:auto;height:40vh;max-width:100%;text-align:right}@media (max-width: 1400px){.rulesIntro .imgSection img{width:90%}}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/rules/landing/slides/slides.component.scss
// module id = 1362
// module chunks = 1